module.exports = __webpack_public_path__ + "img/lock.b2eee2a3.svg";